module.exports = __webpack_public_path__ + "img/cabling.38af0b6c.jpg";